export default "__VITE_ASSET__Dq7dED8k__"